

// import React, { useEffect, useState } from 'react';
// import { Download, Smartphone, X, ShieldCheck } from 'lucide-react';

// const Downloadbutton = () => {
//   const [supportsPWA, setSupportsPWA] = useState(false);
//   const [promptInstall, setPromptInstall] = useState(null);
//   const [isDismissed, setIsDismissed] = useState(false);

//   useEffect(() => {
//     const handler = (e) => {
//       e.preventDefault();
//       console.log('PWA prompt triggered');
//       setSupportsPWA(true);
//       setPromptInstall(e);
//     };

//     window.addEventListener('beforeinstallprompt', handler);

//     return () => window.removeEventListener('beforeinstallprompt', handler);
//   }, []);

//   const onClick = (evt) => {
//     evt.preventDefault();
//     if (!promptInstall) return;

//     promptInstall.prompt();
//     promptInstall.userChoice.then((choiceResult) => {
//       if (choiceResult.outcome === 'accepted') {
//         setSupportsPWA(false);
//       }
//     });
//   };

//   if (!supportsPWA || isDismissed) {
//     return null;
//   }

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@600;700;800&display=swap');

//         .pwa-sticky-bar-wrapper {
//           position: fixed;
//           /* Adjusted bottom value to sit nicely above the navigation/footer */
//           bottom: 100px;
//           /* Absolute horizontal centering */
//           left: 50%;
//           transform: translateX(-50%);
//           /* Width constraints to ensure it doesn't touch the very edges of mobile screens */
//           width: calc(100% - 32px);
//           max-width: 420px;
//           margin: 0 auto;
//           z-index: 9990;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           pointer-events: auto;
//           animation: slideUpFloat 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
//         }

//         .pwa-glass-card {
//           position: relative;
//           background: rgba(15, 23, 42, 0.92);
//           backdrop-filter: blur(20px);
//           -webkit-backdrop-filter: blur(20px);
//           border: 1px solid rgba(255, 255, 255, 0.96);
//           border-radius: 20px;
//           padding: 12px 16px;
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6),
//                       inset 0 1px 0 rgba(255, 255, 255, 0.2);
//           overflow: hidden;
//         }

//         .pwa-glass-card::before {
//           content: '';
//           position: absolute;
//           top: -50%;
//           left: -20%;
//           width: 80%;
//           height: 200%;
//           background: radial-gradient(circle, rgba(16, 185, 129, 0.15) 0%, rgba(0, 0, 0, 0) 70%);
//           pointer-events: none;
//         }

//         .pwa-left-content {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           z-index: 2;
//         }

//         .pwa-icon-box {
//           width: 44px;
//           height: 44px;
//           border-radius: 12px;
//           background: linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(5, 150, 105, 0.1) 100%);
//           border: 1px solid rgba(16, 185, 129, 0.3);
//           color: #34d399;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           flex-shrink: 0;
//           box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
//         }

//         .pwa-text-group {
//           display: flex;
//           flex-direction: column;
//         }

//         .pwa-app-title {
//           color: #f8fafc;
//           font-size: 0.85rem;
//           font-weight: 800;
//           line-height: 1.2;
//           letter-spacing: -0.01em;
//         }

//         .pwa-app-subtitle {
//           color: #10b981;
//           font-size: 0.7rem;
//           font-weight: 700;
//           display: flex;
//           align-items: center;
//           gap: 4px;
//           margin-top: 2px;
//         }

//         .pwa-right-actions {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           z-index: 2;
//         }

//         .pwa-install-btn {
//           position: relative;
//           background: linear-gradient(135deg, #10b981 0%, #059669 100%);
//           color: #ffffff;
//           border: none;
//           outline: none;
//           padding: 8px 16px;
//           border-radius: 12px;
//           font-size: 0.8rem;
//           font-weight: 800;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           gap: 6px;
//           box-shadow: 0 4px 14px rgba(16, 185, 129, 0.4);
//           transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
//           overflow: hidden;
//           animation: pulseGlow 2s infinite ease-in-out;
//         }

//         .pwa-install-btn:hover {
//           transform: translateY(-1px) scale(1.02);
//           box-shadow: 0 6px 18px rgba(16, 185, 129, 0.55);
//         }

//         .pwa-install-btn:active {
//           transform: translateY(0) scale(0.96);
//         }

//         .shimmer-line {
//           position: absolute;
//           top: 0;
//           left: -100%;
//           width: 50%;
//           height: 100%;
//           background: linear-gradient(
//             90deg,
//             transparent,
//             rgba(255, 255, 255, 0.35),
//             transparent
//           );
//           transform: skewX(-20deg);
//           animation: shimmerPass 2.8s infinite;
//         }

//         .pwa-close-btn {
//           background: rgba(255, 255, 255, 0.05);
//           border: 1px solid rgba(255, 255, 255, 0.91);
//           color: #64748b;
//           width: 32px;
//           height: 32px;
//           border-radius: 8px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           transition: all 0.2s ease;
//         }

//         .pwa-close-btn:hover {
//           background: rgba(255, 255, 255, 0.15);
//           color: #f8fafc;
//         }

//         @keyframes slideUpFloat {
//           0% {
//             opacity: 0;
//             transform: translate(-50%, 30px);
//           }
//           100% {
//             opacity: 1;
//             transform: translate(-50%, 0);
//           }
//         }

//         @keyframes pulseGlow {
//           0% {
//             box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.5);
//           }
//           70% {
//             box-shadow: 0 0 0 10px rgba(16, 185, 129, 0);
//           }
//           100% {
//             box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
//           }
//         }

//         @keyframes shimmerPass {
//           0% { left: -100%; }
//           30% { left: 200%; }
//           100% { left: 200%; }
//         }
//       `}</style>

//       <div className="pwa-sticky-bar-wrapper">
//         <div className="pwa-glass-card">
          
//           <div className="pwa-left-content">
//             <div className="pwa-icon-box">
//               <Smartphone size={22} />
//             </div>
//             <div className="pwa-text-group">
//               <span className="pwa-app-title">BAJIGERLUDO Official App</span>
//               <span className="pwa-app-subtitle">
//                 <ShieldCheck size={12} /> Fast & Secure APK
//               </span>
//             </div>
//           </div>

//           <div className="pwa-right-actions">
//             <button className="pwa-install-btn" onClick={onClick}>
//               <span className="shimmer-line"></span>
//               <Download size={15} />
//               <span>INSTALL</span>
//             </button>

//             <button
//               className="pwa-close-btn"
//               onClick={() => setIsDismissed(true)}
//               aria-label="Dismiss banner"
//             >
//               <X size={16} />
//             </button>
//           </div>

//         </div>
//       </div>
//     </>
//   );
// };

// export default Downloadbutton;


import React, { useEffect, useState } from 'react';
import { Download, Smartphone, X, ShieldCheck, Zap, Sparkles } from 'lucide-react';
// import './Downloadbutton.css';

const Downloadbutton = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      console.log('PWA prompt triggered');
      setSupportsPWA(true);
      setPromptInstall(e);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) return;

    promptInstall.prompt();
    promptInstall.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        setSupportsPWA(false);
      }
    });
  };

  if (!supportsPWA || isDismissed) {
    return null;
  }

  return (
    <>
      {/* Dimmed Background Overlay */}
      <div className="pwa-backdrop-overlay" onClick={() => setIsDismissed(true)} />

      {/* Centered Premium Modal Card */}
      <div className="pwa-modal-wrapper">
        <div className="pwa-modal-card">
          {/* Top Brand Accent Bar */}
          <div className="pwa-accent-top" />

          {/* Close Button */}
          <button
            className="pwa-close-btn"
            onClick={() => setIsDismissed(true)}
            aria-label="Close modal"
          >
            <X size={16} />
          </button>

          {/* App Icon */}
          <div className="pwa-brand-icon-wrap">
            <Smartphone size={32} />
          </div>

          {/* Verification Badge */}
          <div className="pwa-badge-pill">
            <ShieldCheck size={12} /> Official Mobile App
          </div>

          {/* Title & Subtitle */}
          <h3 className="pwa-modal-title">Install BAJIGERLUDO</h3>
          {/* <p className="pwa-modal-desc">
            Enjoy instant battles, faster loading, and seamless secure gameplay directly from your home screen.
          </p> */}

          {/* Quick Features Row */}
          <div className="pwa-features-row">
            <div className="pwa-feature-item">
              <Zap size={13} color="#0082cd" /> Fast Speed
            </div>
            <div className="pwa-dot-divider" />
            <div className="pwa-feature-item">
              <Sparkles size={13} color="#ffcd00" /> 100% Safe
            </div>
          </div>

          {/* Main Action Install Button */}
          <button className="pwa-install-btn" onClick={onClick}>
            <span className="pwa-shimmer-line" />
            <Download size={18} />
            <span>INSTALL APP NOW</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Downloadbutton;